import {
  QUERY_IS_LOADING,
  QUERY_NOT_LOADING,
  REQUEST_BANNERS,
  REQUEST_EVENTS,
  REQUEST_FILTERS
} from '../types';
import axios from 'axios';
import {apiUrl} from './../config/index';

export function requestEvents(){
  return (dispatch) => {
    dispatch(queryIsLoading());
    axios.post(`${apiUrl}/event/`, 
    {
      categories:null,
      company:null,
      dateStart:1546319892,
      dateEnd:null,
      status:null
    }).then(result => {
      let data = result.data.Data.map((data) => {
        return {
          ...data,
          id:data.id.toString(),
          company:{
            ...data.company,
            socialNetwork:JSON.parse(data.company.socialNetwork)
          },
          address:JSON.parse(data.address)
        }
      })
      dispatch(rqEvents(data));
      dispatch(queryNotLoading());
    }).catch(error => {
      console.log(error);
      dispatch(queryNotLoading());
    })
  }
}

export function requestFilters(){
  return (dispatch) => {
    dispatch(queryIsLoading());
    axios.get(`${apiUrl}/loadFilters`).then(result => {
      dispatch(rqFilters(result.data));
      dispatch(requestEvents());
    }).catch(error => {
      dispatch(queryNotLoading());
      console.log(error);
    })
  }
}

export const rqFilters = filters => ({
  type: REQUEST_FILTERS,
  payload: filters
})

export const rqEvents = (data) => ({
  type: REQUEST_EVENTS,
  payload: data
});

export const queryIsLoading = () => ({
  type: QUERY_IS_LOADING
});

export const queryNotLoading = () => ({
  type: QUERY_NOT_LOADING
});

export const rqBanners = banners => ({
  type: REQUEST_BANNERS,
  payload: banners
});